module.exports = __webpack_public_path__ + "img/wood-table.1d9524b2.png";